export enum PricingType {
    HOUR = 'HOUR',
    UNIT = 'UNIT',
    FIXED_PRICE = 'FIXED_PRICE',
    FIXED_PRICE_PER_MONTH = 'FIXED_PRICE_PER_MONTH',
}